export const testimonialsConfig = {
  sectionBadge: "تجارب مرضانا",
  sectionBadgeEn: "Patient Stories",
  sectionTitle: "ماذا يقول من اختاروا الفهم الحقيقي؟",
  sectionTitleEn: "What Do Those Who Chose True Understanding Say?",
  sectionSubtitle: "مرضى لم تمنحهم الزيارات السريعة صورة واضحة — حتى جاؤوا إلى ذا مديكال أفينيو",
  sectionSubtitleEn: "Patients who did not get a clear picture from rushed visits — until they came to The Medical Avenue",
  displayStyle: "slider",
  showRating: true,
  showImage: true,
};

export const testimonialsData = [
  {
    id: "t1",
    name: "م. عبدالرحمن الفيصل",
    nameEn: "Eng. Abdulrahman Al-Faisal",
    specialty: "مريض — منصة الطب الدقيق",
    specialtyEn: "Patient — Precision Medicine Platform",
    text: "بعد سنوات من الزيارات السريعة التي لم تعطني صورة واضحة، جاءت جلسة التقييم في ذا مديكال أفينيو لتغير كل شيء. 90 دقيقة من الاستماع الحقيقي والتحليل العميق. أخيرًا فهمت ما يحدث في جسمي.",
    textEn: "After years of brief visits that yielded no clear picture, the assessment session at The Medical Avenue changed everything. 90 minutes of true listening and deep analysis. I finally understood what was happening in my body.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20man%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2045%20years%20old&width=100&height=100&seq=test-ma1&orientation=squarish",
    date: "مارس 2026",
    service: "منصة الطب الدقيق",
    serviceEn: "Precision Medicine Platform",
    verified: true,
    published: true,
    featured: true,
  },
  {
    id: "t2",
    name: "د. منى الشريف",
    nameEn: "Dr. Mona Al-Sharif",
    specialty: "مريضة — DNA Risk Score",
    specialtyEn: "Patient — DNA Risk Score",
    text: "DNA Risk Score كشف استعدادًا وراثيًا لم أكن أعلم به. الآن لدي خطة وقائية حقيقية مبنية على بيولوجيتي الخاصة، لا على بروتوكول عام. هذا هو الطب الذي كنت أبحث عنه.",
    textEn: "The DNA Risk Score uncovered a genetic predisposition I was unaware of. Now I have a real preventive plan built on my unique biology, not a generic protocol. This is the medicine I had been looking for.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20woman%20hijab%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2038%20years%20old&width=100&height=100&seq=test-ma2&orientation=squarish",
    date: "فبراير 2026",
    service: "DNA Risk Score",
    serviceEn: "DNA Risk Score",
    verified: true,
    published: true,
    featured: true,
  },
  {
    id: "t3",
    name: "خالد المطيري",
    nameEn: "Khaled Al-Mutairi",
    specialty: "مريض — Second Opinion الدولي",
    specialtyEn: "Patient — International Second Opinion",
    text: "Second Opinion من مركز أمريكي متخصص غيّر قرار العلاج بالكامل. الفريق في ذا مديكال أفينيو نظّم كل شيء باحترافية عالية. هذا ليس مجرد رأي إضافي، هذا قرار طبي أكثر اطمئنانًا.",
    textEn: "An international Second Opinion from a specialized US center completely changed my treatment decision. The Medical Avenue team organized everything with utmost professionalism. It is not just another opinion, but a more confident clinical choice.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20man%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2052%20years%20old&width=100&height=100&seq=test-ma3&orientation=squarish",
    date: "يناير 2026",
    service: "Second Opinion الدولي",
    serviceEn: "International Second Opinion",
    verified: true,
    published: true,
    featured: false,
  },
  {
    id: "t4",
    name: "سلمى العتيبي",
    nameEn: "Salma Al-Otaibi",
    specialty: "مريضة — الخلل الأيضي",
    specialtyEn: "Patient — Metabolic Health",
    text: "كنت أعاني من مشاكل في الوزن لسنوات دون نتيجة. في ذا مديكال أفينيو فهموا أن المشكلة أعمق من مجرد نظام غذائي. الخطة الشخصية التي وضعوها غيّرت حياتي.",
    textEn: "I struggled with weight issues for years without results. At The Medical Avenue, they understood the issue was deeper than just a diet. The personalized plan they crafted changed my life.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20woman%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2035%20years%20old%20no%20hijab&width=100&height=100&seq=test-ma4&orientation=squarish",
    date: "ديسمبر 2025",
    service: "السمنة والخلل الأيضي",
    serviceEn: "Obesity & Metabolic Health",
    verified: true,
    published: true,
    featured: false,
  },
  {
    id: "t5",
    name: "أ. فهد الدوسري",
    nameEn: "Fahad Al-Dossary",
    specialty: "مريض — التقييم العميق",
    specialtyEn: "Patient — Deep Assessment",
    text: "جلسة التقييم كانت تجربة مختلفة تمامًا. الطبيب استمع لكل شيء، ربط بين أعراض كنت أظنها منفصلة، وخرجت بصورة واضحة لأول مرة. أنصح كل من يبحث عن إجابات حقيقية.",
    textEn: "The assessment session was a completely different experience. The doctor listened to everything, connected symptoms I thought were unrelated, and gave me clarity for the first time. I recommend it to anyone seeking real answers.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20man%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2040%20years%20old&width=100&height=100&seq=test-ma5&orientation=squarish",
    date: "نوفمبر 2025",
    service: "التقييم العميق الشامل",
    serviceEn: "Comprehensive Deep Assessment",
    verified: false,
    published: true,
    featured: false,
  },
  {
    id: "t6",
    name: "ريم الحمدان",
    nameEn: "Reem Al-Hamdan",
    specialty: "مريضة — الطب النفسي",
    specialtyEn: "Patient — Psychiatry",
    text: "التقييم النفسي في ذا مديكال أفينيو مختلف تمامًا. لم يكتفوا بالأعراض، بل فهموا الصورة الكاملة. الخطة العلاجية كانت مخصصة لي تمامًا وليست نسخة من بروتوكول عام.",
    textEn: "The psychiatric evaluation at The Medical Avenue was truly distinct. They did not stop at symptoms, but understood the full picture. The treatment plan was tailored to me rather than a standard cookie-cutter protocol.",
    rating: 4,
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20woman%20hijab%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2030%20years%20old&width=100&height=100&seq=test-ma6&orientation=squarish",
    date: "أكتوبر 2025",
    service: "الطب النفسي للبالغين",
    serviceEn: "Adult Psychiatry",
    verified: true,
    published: false,
    featured: false,
  },
];

export const testimonialsStats = {
  averageRating: 4.9,
  totalReviews: 248,
  fiveStars: 94,
  fourStars: 5,
  threeStars: 1,
};
